export enum CaseTaskEditorType {
  WorkflowEdit,
  TaskEdit,
}
